import React, { useEffect, useRef, useState } from "react";
import Input from "../../../components/Input";
import { HexColorPicker } from "react-colorful";

const ColorPicker = ({ color, setColor }) => {
  const [isPickerVisible, setIsPickerVisible] = useState(false);
  const pickerRef = useRef(null);

  const handleColorChange = e => {
    setColor(e.target.value);
  };

  const togglePicker = () => {
    setIsPickerVisible(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsPickerVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex items-center space-x-4 relative" ref={pickerRef}>
      <button
        type="button"
        className="relative pl-1 pt-1 w-[2rem] h-[2rem] flex items-center justify-center cursor-pointer"
        onClick={togglePicker}
      >
        <div
          className="absolute w-full h-full rounded-full"
          style={{
            border: `2px solid ${color}`,
          }}
        />
        <div
          className="absolute w-[1.5rem] h-[1.5rem] rounded-full"
          style={{ background: color }}
        />
      </button>

      <Input value={color} onChange={handleColorChange} />

      {isPickerVisible && (
        <div className="absolute bottom-full mb-2 z-10">
          <HexColorPicker color={color} onChange={setColor} />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
